import React from 'react';

import './logoslist.scss';
import { DefaultBsComponent, PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';
import { Logo, LogoProps } from '../../components/Logo';
import { applyBgColor } from '../../utils/utils';
import { textBody, textBodyUppercase } from '../../styles/typography';
import { container } from '../../styles/themes';
import { AutoScrollingCards } from '../../components/AutoScrollingCards';

export interface LogosListProps extends DefaultBsComponent {
  color?: PayFitColor;
  isDark?: boolean;
  isEncapsulated?: boolean;
  isAnimated?: boolean;
  className?: string;
  title?: string;
  subtitle?: string;
  logos: LogoProps[];
}

export const LogosList = ({
  color,
  isDark = false,
  isEncapsulated = false,
  isAnimated = false,
  className,
  title = '',
  subtitle = '',
  logos,
  as: Component = 'div',
}: LogosListProps) => {
  const applyDark = color === 'white' ? false : isDark;

  return (
    <Component
      className={classNames(
        'logos-list overflow-hidden',
        applyBgColor(color, applyDark, ''),
        className,
      )}
    >
      {(title || subtitle) && (
        <div
          className={classNames(
            container,
            'logos-list__title-container flex flex-col text-center items-center z-[1]',
          )}
        >
          {title && (
            <h2
              className={classNames(
                'logos-list__title md:w-5/8 lg:w-6/12',
                applyDark ? 'text-neutral-1' : 'text-neutral-101',
                'pb-24',
                textBodyUppercase,
              )}
            >
              {title}
            </h2>
          )}
          {subtitle && (
            <p
              className={classNames(
                'logos-list__subtitle md:w-5/8 lg:w-6/12',
                applyDark ? 'text-neutral-1' : 'text-neutral-101',
                'pb-64',
                textBody,
              )}
            >
              {subtitle}
            </p>
          )}
        </div>
      )}

      {!isAnimated ? (
        <div className={classNames(container, 'flex justify-center')}>
          <div
            className={classNames(
              'flex rounded-12 overflow-hidden',
              isEncapsulated
                ? 'logos-container-encapsulated'
                : 'logos-container-free',
              'flex-wrap items-center justify-center',
              color !== 'white' && isEncapsulated && 'bg-neutral-1',
            )}
          >
            {logos.map((logo, key) => (
              <Logo {...{ ...logo, isEncapsulated }} key={key} />
            ))}
          </div>
        </div>
      ) : (
        <div className="mb-12">
          <AutoScrollingCards inverse={true} gap={10} duration={42000}>
            {logos.map(({ className, ...logo }, key) => (
              <Logo
                {...{ ...logo, isEncapsulated }}
                className={classNames(className, 'rounded-8')}
                key={key}
                classNameLogo={classNames('max-w-max max-h-[36px]', 'w-auto')}
              />
            ))}
          </AutoScrollingCards>
        </div>
      )}
    </Component>
  );
};
